import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
    Button,
    Select,
    DatePicker,
    Form,
    message,
    Dropdown,
    Menu,
    Popconfirm,
    Modal,
    Typography,
    Tag,
    Upload,
    Radio,
    Input,
    Col,
    Space,
    Collapse
} from 'antd';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Icon } from '@ant-design/compatible';
import { GET_DASHBOARD_ITEMS } from '../../graphql/queries'
import { UPDATE_DASHBOARD_ITEM } from '../../graphql/mutations'
import time from '../../utils/time'
import chart from '../../utils/chart'
import moment from "moment";
import { Fileuploader } from '@ap-evolved/evolved-ui.ui.fileuploader'
import { v4 as uuidv4 } from 'uuid'
import { QueryBuilder } from '@cubejs-client/react'
import FilterGroup from '../QueryBuilder/FilterGroup'
import dashboardFilter from '../../utils/dashboardFilter'
import useQueryUpdater from './useQueryUpdater'
import DateRangeSelect from './DateRangeSelect'
import styles from './styles'
import DimFilterSelect from './DimFilterSelect'
import MenuOptions from './MenuOptions'
import PropTypes from 'prop-types';
import FilterContext from './FilterContext'

const { Panel } = Collapse

const Filters = ({
    tableName,
    timeColumn,
    dimensionOptions,
    filterState,
    handleFilterChange,
    handleApply,
    handleResetAll,
    afterUpload,
    handleExport
}) => {

    /* useForm */
    const [form] = Form.useForm()

    const [state, setState] = useState({ export: false, reset: false })

    const exportOptions = [
        {
            value: 'filtered',
            text: 'With current filter settings'
        },
        {
            value: 'all',
            text: 'Reset filter settings'
        }
    ]

    const contextValues = {
        tableName,
        timeColumn,
        dimensionOptions,
        afterUpload,
        exportOptions,
        filterState,
        handleFilterChange,
        state,
        setState
    }

    useEffect(() => {
        if (state.reset) {
            handleResetAll()
        }
        if (state.export) {
            console.log("Export requested, dashboard reset is ", state.reset)
            let timeoutDuration = state.reset ? 5000 : 1
            setTimeout(() => {
                handleExport()
            }, timeoutDuration)

            setState({ ...state, export: false, reset: false })
        }
    }, [state])


    return (
        <FilterContext.Provider value={contextValues}>

            <Form
                form={form}
                layout="vertical"
                style={styles.form()}
            >
                <div style={styles.majorRowDiv()}>
                    <div style={{ width: '95%' }}>
                        <div style={styles.filterRowDiv()}>
                            <Form.Item
                                style={{ paddingRight: 30 }}
                                label={
                                    <label style={styles.formLabel()}>
                                        TIME PERIOD
                                        </label>
                                }>
                                <DateRangeSelect />
                            </Form.Item>
                            <DimFilterSelect />
                        </div>
                        <div style={styles.filterRowDiv(true)}>
                            <Button
                                onClick={handleResetAll}
                                type='link'
                                default
                                style={{ margin: '10px 10px 10px 0px' }}
                            >
                                Reset all
                    </Button>
                            <Button
                                onClick={handleApply}
                                type='primary'
                                style={{ borderRadius: '20px', margin: '10px 20px 10px 0px' }}
                            >
                                Apply
                    </Button>
                        </div>
                    </div>
                    <MenuOptions />
                </div>
            </Form >


        </FilterContext.Provider>
    )

}

Filters.propTypes = {
    tableName: PropTypes.string,
    timeColumn: PropTypes.string,
    dimensionOptions: PropTypes.arrayOf(PropTypes.object),
    filterState: PropTypes.object,
    handleFilterChange: PropTypes.func,
    handleApply: PropTypes.func,
    handleResetAll: PropTypes.func,
    afterUpload: PropTypes.func,
    handleExport: PropTypes.func
};
Filters.defaultProps = {
    tableName: null,
    timeColumn: 'date',
    dimensionOptions: [],
    filterState: {},
    handleFilterChange: () => { },
    handleApply: () => { },
    handleResetAll: () => { },
    afterUpload: () => { console.log('upload complete!') },
    handleExport: () => { console.log("Exporting!") }
};

export default Filters